import { formatPrice } from "../../utils/price";

export const createProductBundle = (element) => {
  if (!element || element.length === 0) {
    return null;
  }

  const instance = {
    $form: null,
    $checkboxes: null,
    $totalElement: null,
    $addToCartButton: null,
    clickHandler: null,

    init: function (element) {
      this.$element = jQuery(element);
      if (this.$element.data("initialized")) return;
      this.$element.attr("data-initialized", true);

      this.$form = this.$element.find("#bundle_form");
      this.$checkboxes = this.$form.find(".bundle-checkbox");
      this.$totalElement = this.$element.find("#bundle_total");
      this.$addToCartButton = this.$form.find("button[type='submit']");

      this.setupEventListeners();
      this.updateTotal();
    },

    setupEventListeners: function () {
      this.$checkboxes.on("change", () => this.updateTotal());
      this.$form.on("submit", (e) => {
        e.preventDefault();
        if (this.clickHandler) {
          this.clickHandler(e);
        }
      });
    },

    updateTotal: function () {
      let total = 0;
      this.$checkboxes.each((_, checkbox) => {
        if (checkbox.checked || checkbox.disabled) {
          total += parseFloat(jQuery(checkbox).data("price"));
        }
      });
      this.$totalElement.text(formatPrice(total));
    },

    hide: function () {
      this.$element.hide();
    },

    /**
     * Get selected product IDs from bundle
     * @returns {Array} - Array of selected product IDs
     */
    getSelectedProducts: function () {
      const selectedProducts = [];
      this.$checkboxes.each((_, checkbox) => {
        if (checkbox.checked) {
          selectedProducts.push(checkbox.value);
        }
      });
      return selectedProducts;
    },

    /**
     * Add click handler for the submit button
     * @param {Function} callback - Function to call on click
     */
    addClickHandler: function (callback) {
      this.clickHandler = callback;
    },

    /**
     * Show loading state on button
     * @param {string} text - Text to display during loading
     */
    loading: function (text) {
      this.$addToCartButton.prop("disabled", true).text(text);
    },

    /**
     * Restore button to normal state
     */
    done: function () {
      this.$addToCartButton
        .prop("disabled", false)
        .text(hs.strings.addToCart || "Add to cart");
    },

    updateCurrentProduct: function ({ priceHtml, image }) {
      const currentProduct = this.$element.find(".js-bundle-product-1");
      const productThumb = currentProduct.find(".js-bundle-product-image img");
      if (image) {
        productThumb.attr({
          src: image.full_src,
          srcset: image.srcset,
          sizes: image.sizes,
        });
      }
      currentProduct.find(".js-bundle-product-price").html(priceHtml);
    },
  };

  instance.init(element);
  return instance;
};
